import {Injectable} from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {catchError, map, Observable, of, throwError} from "rxjs";
import {CommonResponse} from "../../customs/_models/Response";
import {SampleDTO} from "../../customs/_models/sampleDTO";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {error} from "@angular/compiler-cli/src/transformers/util";
import { SampleCountDTO } from '../../customs/_models/SampleCountDTO';
import { DevisDTO } from '../../customs/_models/DevisDTO';
import { environment } from '../../../environments/environment';
import { LotDto } from '../../customs/_models/LotDto';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LotService {

    constructor(
        private endpoints: Endpoints,
        private http: HttpClient) {
    }

        private baseUrl = environment.base_url;
    

    private apiUrl = this.baseUrl+'/api/batch';
        private apiUrl1 = this.baseUrl+'/api/signature';


        addSignature(reportId: number, signatureData: string): Observable<any> {
    return this.http.post(`${this.apiUrl1}/save`, { signatureData });
  }
    saveSignature(data: any): Observable<any> {
      return this.http.post(`${this.apiUrl1}/save`, data); // Remplace l'URL par celle de ton API
    }
        // Créer un nouveau lot
        createBatch(batchDto: LotDto) {
          return this.http.post<LotDto>(this.apiUrl, batchDto, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
          });
        }
      
        // Mettre à jour un lot existant
        updateBatch(id: number, batchDto: LotDto) {
          return this.http.put<LotDto>(`${this.apiUrl}/${id}`, batchDto, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
          });
        }
      
        // Récupérer tous les lots
        getAllBatches() {
          return this.http.get<LotDto[]>(this.apiUrl);
        }
      
        // Récupérer un lot par son ID
        getBatchById(id: number) {
          return this.http.get<LotDto>(`${this.apiUrl}/${id}`);
        }
      
        // Supprimer un lot
        deleteBatch(id: number) {
          return this.http.delete<void>(`${this.apiUrl}/${id}`);
        }

        private openSampleModalSource = new Subject<number>();
        openSampleModal$ = this.openSampleModalSource.asObservable();
        
        requestOpenSampleModal(batchId: number) {
          console.log('📨 Requête d’ouverture du modal Sample avec batchId :', batchId);
          this.openSampleModalSource.next(batchId);
        }   
        
      downloadPdfByBatchId(batchId: number): void {
            this.http.get(`${this.apiUrl}/pdf/by-batch/${batchId}`, {
              responseType: 'blob'
            }).subscribe(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `rapport-batch-${batchId}.pdf`;
              a.click();
              window.URL.revokeObjectURL(url);
            }, error => {
              console.error('Erreur lors du téléchargement du rapport PDF', error);
            });
          }
      downloadPdfCodeBarre(batchId: number): void {
            this.http.get(`${this.apiUrl}/pdf/codeBarre/${batchId}`, {
              responseType: 'blob'
            }).subscribe(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `CodeBarre-batch-${batchId}.pdf`;
              a.click();
              window.URL.revokeObjectURL(url);
            }, error => {
              console.error('Erreur lors du téléchargement du rapport PDF', error);
            });
          }


          
          generateReportsForBatches(batchIds: number[]) {
            let url = `${this.apiUrl}/generate-reports`;  // Endpoint pour les rapports des lots
            const headers = new HttpHeaders({'Content-Type': 'application/json'});
            
            return this.http.post(url, batchIds, { headers, responseType: 'json' });
        }
        generateCodeBarreForBatches(batchIds: number[]) {
          let url = `${this.apiUrl}/generate-codeBarres`;  // Endpoint pour les rapports des lots
          const headers = new HttpHeaders({'Content-Type': 'application/json'});
          
          return this.http.post(url, batchIds, { headers, responseType: 'json' });
      }
      }
      